import { memo } from 'react'

import s from './NoContent.module.scss'

interface Props {
  title: string
  subtitle: string
  icon: string
}

export const NoContent = memo(({ title, subtitle, icon }: Props) => {
  return (
    <div className={s.wrapper}>
      <img src={icon} alt="" className={s.icon} />
      <h1 className={s.title}>{title}</h1>
      <p className={s.subtitle}>{subtitle}</p>
    </div>
  )
})
